/**
 * Canonical cold-entry paths for public marketing boot.
 * Opt-in only: new landings must be added here explicitly (+ tests).
 * Keep `/` and `/start` eager in publicRouteGroup — do not lazyWithGuard them.
 */
const stripQueryAndHash = (value: string) => value.split(/[?#]/, 1)[0] || value;

export const BOOT_COLD_ENTRY_PATHS = ["/", "/start"] as const;

export type BootColdEntryPath = (typeof BOOT_COLD_ENTRY_PATHS)[number];

const BOOT_COLD_ENTRY_PATH_SET = new Set<string>(BOOT_COLD_ENTRY_PATHS);

export function isBootColdEntryPath(pathname: string): boolean {
  return BOOT_COLD_ENTRY_PATH_SET.has(stripQueryAndHash(pathname));
}
